"use client";

import React from "react";
import clsx from "clsx";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WORKBENCH_CARD_META_CLASS } from "@/components/ui/workbench";
import { CHAT_ENTITY_CARD_CANDIDATE_BUTTON_CLASS, CHAT_ENTITY_CARD_ICON_CLASS } from "./entityPreviewUi";

type ChatEntityCardRowProps = {
  icon?: IconDefinition;
  label: string;
  hint?: string;
  detail?: string;
  trailing?: React.ReactNode;
  onClick?: () => void;
  testId?: string;
  className?: string;
};

export function ChatEntityCardRow({
  icon,
  label,
  hint,
  detail,
  trailing,
  onClick,
  testId,
  className,
}: ChatEntityCardRowProps) {
  const body = (
    <>
      {icon ? <FontAwesomeIcon icon={icon} className={CHAT_ENTITY_CARD_ICON_CLASS} aria-hidden /> : null}
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-slate-900 dark:text-slate-100">{label}</p>
        {hint ? <p className={clsx("truncate text-xs", WORKBENCH_CARD_META_CLASS)}>{hint}</p> : null}
        {detail ? (
          <p className={clsx("truncate text-xs", WORKBENCH_CARD_META_CLASS)}>{detail}</p>
        ) : null}
      </div>
      {trailing}
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        data-testid={testId}
        onClick={onClick}
        className={clsx(CHAT_ENTITY_CARD_CANDIDATE_BUTTON_CLASS, className)}
      >
        {body}
      </button>
    );
  }

  return (
    <div data-testid={testId} className={clsx(CHAT_ENTITY_CARD_CANDIDATE_BUTTON_CLASS, className)}>
      {body}
    </div>
  );
}
